<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item label="状态">
        <el-select v-model="query.status" placeholder="请选择状态" clearable style="width: 150px">
          <el-option label="可用" :value="1"></el-option>
          <el-option label="停用" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="openAdd">新增</el-button>
      </el-form-item>
    </el-form>

    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #weeks="{ row }">
        <div>{{ getWeekName(row.weeks) }}</div>
      </template>
      <template #status="{ row }">
        <el-tag size="small" type="success" v-if="row.status === 1">可用</el-tag>
        <el-tag size="small" type="danger" v-if="row.status === 2">停用</el-tag>
      </template>
      <template #handle="{ row }">
        <el-button size="small" type="success" @click="openUpdate(row)">编辑</el-button>
      </template>
    </auto-table>

    <addEdit ref="edit" @success="getList(1)"></addEdit>
  </div>
</template>

<script>
import addEdit from './coachTime/addEdit.vue';

export default {
  components: {
    addEdit
  },
  data() {
    return {
      nav: { firstNav: "教练管理", secondNav: "教练可服务时间" },
      DataList: [],
      query: {
        weeks: null,
        status: null,
        coach_id: this.$route.query.id || null
      },
      Option: [
        { name: "星期", value: "weeks", type: "custom" },
        { name: "时间段", value: "times_range" },
        { name: "状态", value: "status", type: "custom" },
        { name: "创建时间", value: "create_time" },
        { name: "操作", value: "handle", type: "custom" }
      ],
      Total: 0
    };
  },

  methods: {
    init(){
        if(this.DataList.length == 0){
                this.getList(1);
        }
    },
    openAdd() {
      this.$refs.edit.open();
    },
    openUpdate(row) {
      this.$refs.edit.open(row);
    },
    getWeekName(week) {
      const weekMap = {
        '0': '周日',
        '1': '周一',
        '2': '周二',
        '3': '周三',
        '4': '周四',
        '5': '周五',
        '6': '周六'
      };
      return weekMap[week] || week;
    },
    // 列表查询
    getList(v) {
      let page = v || 1;
      let params = {
        currentPage: page,
        pageSize: 10,
        ...this.query
      };
      this.$axios({
        url: "/user/coachTimes/queryListPage",
        params
      }).then((res) => {
        this.DataList = res.data.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
